// extracted by mini-css-extract-plugin
export default {"candidates":"styles_candidates__bTDSo","title":"styles_title__tTDGq","noMatch":"styles_noMatch__W3bg1","seeAll":"styles_seeAll__o8blR"};